var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabDatas)?_c('div',{staticClass:"tabs"},[_c('my-form',{attrs:{"data":_vm.formData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }